import React,{useEffect} from 'react';
import {exportPdf} from '../../function_lib/common_lib';

export function Comp_View_Cert_Steering(props){
  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divCertSteeringRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Steering Records</h5>
          <a href={"javascript:void(0)"} onClick={()=>exportPdf("Steering Certificate","ptr_steering_cert")} className="btn btn-sm btn-danger float-right">Pdf/Print</a>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        
       
        <div id="ptr_steering_cert" className="modal-body">
             {/* form content  */}
             <div class="steering-certificate">
        <div class="header-container">
            <div class="header-box">Section 9.6- Steering Certificate</div>
            <div class="header-box">To be issued by the Master once all<br/>
            Steering Training is completed and<br/>
            the cadet is considered proficient. 
            n</div>
        </div>
        
        <div class="logo-container">
            <img src="../logo.png" alt="GlobalMET Logo" class="main-logo"/>
            <img src="../dg_shipping_logo.png" alt="General Logo" class="logo"/>
            {/* <img src="../umulogo.png" alt="Maritime Logo" class="logo"/> */}
        </div>
        
        <div class="certificate-title">Steering Certificate</div>
        
        <div class="cadet-info">
            Name of Cadet: _______________________________<br/>
            Date of birth: _______________________________<br/>
            Passport number: _____________________________<br/>
            CDC No. :___________________________<br/>
            INDOS No. :_____________________________<br/>
        </div>
        
        <div class="headingg">This is to certify that the above named Cadet has served on board the ship</div>
        
        <div class="ship-period-line">
            <span></span> from <span></span> to <span></span>.
        </div>
        
        <div class="description">
        During this period of structured shipboard training, the Cadet took turns at steering the ship (apart from the periods of instruction) as given below: 
        </div>
        
        <div  class="headingg">The number of bridge watches kept is as follows:</div>
        
        <div class="table-container">
            <table class="table">
                <tr>
                    <th>Steering</th>
                    <th>Total Hours </th>
                </tr>
                <tr>
                    <td>By compass during day </td>
                    <td></td>
                    
                </tr>
                <tr>
                    <td>By compass during night</td>
                    <td></td>
                   
                </tr>
                <tr>
                    <td>By sight (without compass)</td>
                    <td></td> 
                </tr>
                <tr>
                    <td>While entering and leaving port</td>
                    <td></td>
                </tr>
            </table>
            <div>
                <div class="signature-container">Master’s signature & ship’s stamp</div>
                <div class="signature-details">
                    <p>Master's Name: __________________________</p>
                    <p>Date: _____________</p>
                </div>
            </div>
        </div>
        <div class="bottom-note">
        This is to certify that the Cadet has been found proficient in steering the ship by hand. 
        </div>
    
      </div>

             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor111 btn-primary">Save</button>
        </div>
        
      </div>
      </div>
      </div>)
}

export default Comp_View_Cert_Steering;